//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createCompany } from '../../../api/company';

export default {
    name: 'create-company-modal',
    props: {
        value: Boolean
    },
    data() {
        return {
            saving: false,
            rules: {
                name: [{ required: true, type: 'string', message: '请输入公司名称', trigger: 'blur' }]
            },
            company: {}
        };
    },
    methods: {
        visibleChange(value) {
            if (!value) {
                this.$emit('input', false);
            }
        },
        cancel() {
            this.$refs.form.resetFields();
            this.$emit('input', false);
        },
        onSave() {
            this.company.type = 10;
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.saving = true;
                    createCompany(this.company).then(res => {
                        this.$Notice.success({
                            duration: 3,
                            title: '保存成功'
                        });
                        this.$emit('input', false);
                        this.$emit('handleSuccess');
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },

        update(data) {
            // console.log('-----')
            this.company = {};
            this.company = JSON.parse(JSON.stringify(data));
        }
    },
    created() {
    }
};
